import { addMessages } from '@hana/i18n';

// Chuỗi Chi tiết Job. Mã nghiệp vụ (ISO 6346, DET), tên riêng, dữ liệu mẫu không dịch.
addMessages('vi', {
  'jobDetail.ph.ov': 'Tổng quan',
  'jobDetail.ph.doc': 'Chứng từ',
  'jobDetail.ph.mail': 'Thư',
  'jobDetail.ph.fee': 'Phí',
  'jobDetail.ph.note': 'Ghi chú',
  'jobDetail.planTitle': 'Kế hoạch vận chuyển',
  'jobDetail.planReason': 'Lý do thay đổi kế hoạch',
  'jobDetail.actNone': 'Chưa có hoạt động loại này.',
  'jobDetail.planChange': 'Thay đổi kế hoạch',
  'jobDetail.noCutoff': 'Chưa có cut-off',
  'jobDetail.gateIn': 'Hạ bãi',
  'jobDetail.gateInTip': 'Cont đã hạ bãi',
  'jobDetail.days': '{n} ngày',
  'jobDetail.from': 'Đi · cảng xếp đầu',
  'jobDetail.to': 'Đến · cảng dỡ cuối',
  'jobDetail.badIso': 'Sai số kiểm ISO 6346',
  'jobDetail.colNo': 'Số cont',
  'jobDetail.colType': 'Loại',
  'jobDetail.colPickup': 'Lấy rỗng · free time DET',
  'jobDetail.retry': 'Thử lại',
  'jobDetail.back': 'Về danh sách',
  'jobDetail.ovRemind': 'Nhắc điều độ',
  'jobDetail.ovFollow': 'Theo dõi',
  'jobDetail.ovPlan': 'Xem kế hoạch',
  'jobDetail.ovPortToPort': 'cảng tới cảng',
  'jobDetail.ovCompose': 'Soạn thư',
  'jobDetail.ovTypeBox': 'Loại & hộp',
  'jobDetail.ovAutoTag': 'Tự gắn · Ask HANA',
  'jobDetail.ovUndo': 'Hoàn tác',
  'jobDetail.ovSkip': 'Bỏ qua',
  'jobDetail.ovNotes': 'Ghi chú & hoạt động →',
  'jobDetail.ovAll': 'Tất cả →',
  'jobDetail.ovChangePic': 'Đổi PIC',
  'jobDetail.ovAskTeam': 'Hỏi nhóm job',
  'jobDetail.ovReqClose': 'Yêu cầu đóng → Kế toán khoá',
});
addMessages('en', {
  'jobDetail.ph.ov': 'Overview',
  'jobDetail.ph.doc': 'Docs',
  'jobDetail.ph.mail': 'Mail',
  'jobDetail.ph.fee': 'Fees',
  'jobDetail.ph.note': 'Notes',
  'jobDetail.planTitle': 'Transport plan',
  'jobDetail.planReason': 'Reason for plan change',
  'jobDetail.actNone': 'No activity of this type yet.',
  'jobDetail.planChange': 'Plan changed',
  'jobDetail.noCutoff': 'No cut-off yet',
  'jobDetail.gateIn': 'Gate-in',
  'jobDetail.gateInTip': 'Containers gated in',
  'jobDetail.days': '{n} days',
  'jobDetail.from': 'From · first port of loading',
  'jobDetail.to': 'To · last port of discharge',
  'jobDetail.badIso': 'Invalid ISO 6346 check digit',
  'jobDetail.colNo': 'Container no.',
  'jobDetail.colType': 'Type',
  'jobDetail.colPickup': 'Empty pick-up · DET free time',
  'jobDetail.retry': 'Retry',
  'jobDetail.back': 'Back to list',
  'jobDetail.ovRemind': 'Remind dispatcher',
  'jobDetail.ovFollow': 'Follow',
  'jobDetail.ovPlan': 'View plan',
  'jobDetail.ovPortToPort': 'port to port',
  'jobDetail.ovCompose': 'Compose',
  'jobDetail.ovTypeBox': 'Type & box',
  'jobDetail.ovAutoTag': 'Auto-tagged · Ask HANA',
  'jobDetail.ovUndo': 'Undo',
  'jobDetail.ovSkip': 'Skip',
  'jobDetail.ovNotes': 'Notes & activity →',
  'jobDetail.ovAll': 'All →',
  'jobDetail.ovChangePic': 'Change PIC',
  'jobDetail.ovAskTeam': 'Ask job team',
  'jobDetail.ovReqClose': 'Request close → Accounting locks',
});

addMessages('vi', {
  'jobDetail.addCont': 'Thêm cont',
  'jobDetail.sendUpdate': 'Gửi cập nhật',
  'jobDetail.denStd': 'Chuẩn',
  'jobDetail.denCompact': 'Gọn',
  'jobDetail.density': 'Mật độ',
});
addMessages('en', {
  'jobDetail.addCont': 'Add container',
  'jobDetail.sendUpdate': 'Send update',
  'jobDetail.denStd': 'Standard',
  'jobDetail.denCompact': 'Compact',
  'jobDetail.density': 'Density',
});

addMessages('vi', {
  'jobDetail.kpiAria': 'Chỉ số nhanh',
  'jobDetail.msAria': 'Mốc của job',
  'jobDetail.peopleAria': 'Người phụ trách',
  'jobDetail.backAria': 'Quay lại danh sách job',
  'jobDetail.searchAria': 'Tìm nhanh (Ctrl K)',
  'jobDetail.propsAria': 'Thuộc tính · Lịch sử',
  'jobDetail.tasksAria': 'Việc · Thông báo',
  'jobDetail.tabsAria': 'Mục của job',
  'jobDetail.moreActions': 'Thao tác khác',
  'jobDetail.listTitle': 'Danh sách job',
  'jobDetail.searchTitle': 'Tìm nhanh · Ctrl K',
  'jobDetail.msTitle': 'Mốc cut-off',
  'jobDetail.infoTitle': 'Thông tin job',
  'jobDetail.cargoTotal': 'Hàng hoá · tổng theo job',
  'jobDetail.contTitle': 'Container · seal · VGM',
  'jobDetail.closeSi': 'Closing SI (hãng)',
  'jobDetail.dlSi': 'Hạn nội bộ nộp SI',
  'jobDetail.closeCy': 'Closing CY (hãng)',
  'jobDetail.dlCy': 'Hạn nội bộ hạ bãi',
  'jobDetail.gateDone': 'Đã hạ {d}',
  'jobDetail.gateNot': 'Chưa hạ',
  'jobDetail.cutPast': 'đã qua',
  'jobDetail.cutHours': 'còn {n}h',
  'jobDetail.cutDays': 'còn {n} ngày',
  'jobDetail.changeStatus': 'Đổi trạng thái job, hiện {s}',
  'jobDetail.pageTitle': 'Chi tiết Job',
  'jobDetail.notFound': 'Không tìm thấy job {id}',
  'jobDetail.notFoundDesc': 'Job có thể đã bị gộp vào job khác hoặc bạn mở từ một liên kết cũ.',
  'jobDetail.tabSoon': 'Mục này chưa dựng ở bản này',
  'jobDetail.tabSoonDesc': 'Sẽ có ở các PR tiếp theo của luồng Job.',
  'jobDetail.tab.ov': 'Tổng quan',
  'jobDetail.tab.cargo': 'Hàng & container',
  'jobDetail.tab.svc': 'Dịch vụ',
  'jobDetail.tab.fc': 'Freight & Charges',
  'jobDetail.tab.cost': 'Chi phí',
  'jobDetail.tab.doc': 'Chứng từ & B/L',
  'jobDetail.tab.inv': 'Hoá đơn',
  'jobDetail.tab.task': 'Việc',
  'jobDetail.tab.note': 'Ghi chú & hoạt động',
  'jobDetail.tab.cargoPad': 'Hàng & cont',
  'jobDetail.tab.notePad': 'Ghi chú',
});

addMessages('en', {
  'jobDetail.kpiAria': 'Quick metrics',
  'jobDetail.msAria': 'Job milestones',
  'jobDetail.peopleAria': 'People in charge',
  'jobDetail.backAria': 'Back to job list',
  'jobDetail.searchAria': 'Quick search (Ctrl K)',
  'jobDetail.propsAria': 'Properties · History',
  'jobDetail.tasksAria': 'Tasks · Notifications',
  'jobDetail.tabsAria': 'Job sections',
  'jobDetail.moreActions': 'More actions',
  'jobDetail.listTitle': 'Job list',
  'jobDetail.searchTitle': 'Quick search · Ctrl K',
  'jobDetail.msTitle': 'Cut-off milestones',
  'jobDetail.infoTitle': 'Job info',
  'jobDetail.cargoTotal': 'Cargo · job total',
  'jobDetail.contTitle': 'Containers · seal · VGM',
  'jobDetail.closeSi': 'Closing SI (carrier)',
  'jobDetail.dlSi': 'Internal SI deadline',
  'jobDetail.closeCy': 'Closing CY (carrier)',
  'jobDetail.dlCy': 'Internal gate-in deadline',
  'jobDetail.gateDone': 'Gated in {d}',
  'jobDetail.gateNot': 'Not gated in',
  'jobDetail.cutPast': 'passed',
  'jobDetail.cutHours': '{n}h left',
  'jobDetail.cutDays': '{n} days left',
  'jobDetail.changeStatus': 'Change job status, now {s}',
  'jobDetail.pageTitle': 'Job detail',
  'jobDetail.notFound': 'Job {id} not found',
  'jobDetail.notFoundDesc': 'The job may have been merged into another job, or you opened an old link.',
  'jobDetail.tabSoon': 'This section is not built yet',
  'jobDetail.tabSoonDesc': 'Coming in upcoming Job updates.',
  'jobDetail.tab.ov': 'Overview',
  'jobDetail.tab.cargo': 'Cargo & containers',
  'jobDetail.tab.svc': 'Services',
  'jobDetail.tab.fc': 'Freight & Charges',
  'jobDetail.tab.cost': 'Costs',
  'jobDetail.tab.doc': 'Documents & B/L',
  'jobDetail.tab.inv': 'Invoices',
  'jobDetail.tab.task': 'Tasks',
  'jobDetail.tab.note': 'Notes & activity',
  'jobDetail.tab.cargoPad': 'Cargo',
  'jobDetail.tab.notePad': 'Notes',
});
